module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewDisplay",
    class: {
      overviewShown: _vm.overviewShown,
      'is-visible-preview': _vm.isVisible
    },
    attrs: {
      "id": "previewAll"
    }
  }, [_c('div', {
    staticClass: "gjs-off-prv exit_preview",
    attrs: {
      "id": "exit"
    },
    on: {
      "click": _vm.showPreview
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "40",
      "viewBox": "0 0 401.994 402"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-296.982 -165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z",
      "transform": "translate(364 232)",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "error",
      "transform": "translate(296.982 165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z",
      "transform": "translate(0 0)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "exit-container"
  }, [_c('div', {
    staticClass: "exit-alert animated fadeOutUp",
    attrs: {
      "id": "animatedExit"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('labels.press')))]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "viewBox": "0 0 401.994 402"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-296.982 -165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M134,0A134,134,0,1,1,0,134,134,134,0,0,1,134,0Z",
      "transform": "translate(364 232)",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "error",
      "transform": "translate(296.982 165)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M343.193,58.8c-78.4-78.4-205.978-78.41-284.388,0s-78.4,205.978,0,284.388,205.978,78.41,284.388,0S421.595,137.206,343.193,58.8ZM280.3,280.3a15.465,15.465,0,0,1-21.872,0L201,222.871l-60.157,60.157a15.466,15.466,0,0,1-21.872-21.872L179.126,201,121.7,143.572A15.466,15.466,0,1,1,143.572,121.7L201,179.126l54.689-54.689A15.466,15.466,0,0,1,277.56,146.31L222.871,201,280.3,258.425A15.465,15.465,0,0,1,280.3,280.3Z",
      "transform": "translate(0 0)"
    }
  })])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('labels.exit_fullScreen')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "reveal"
  }, [_c('div', {
    staticClass: "slidesParent preview-scaling",
    class: _vm.deviceType,
    style: (_vm.devices.style)
  }, [_c('div', {
    staticClass: "slides"
  }, _vm._l((_vm.slides), function(slide) {
    return (_vm.isVisible) ? _c('section', {
      attrs: {
        "data-transition": slide.transition,
        "data-autoslide": slide.duration
      }
    }, [_c('div', {
      staticStyle: {
        "height": "100%"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHtml(slide.html))
      }
    })]) : _vm._e()
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a8a359","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = 834
// module chunks = 1 3